import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { MobileGenresComponents, MobileGenresStores } from "../react_isomorphic/mobile/genres";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { merge } from "lodash";

window.ReactComponents = merge({}, GlobalComponents, HeaderComponents, MobileGenresComponents);
window.ReactStores = merge({}, GlobalStores, HeaderStores, MobileGenresStores);
